import addressField from './address-field.svg';
import alignCenter from './align-center.svg';
import alignJustify from './align-justify.svg';
import alignLeft from './align-left.svg';
import alignRight from './align-right.svg';
import ambulance from './ambulance.svg';
import anchor from './anchor.svg';
import archive from './archive.svg';
import arrowDown from './arrow-down.svg';
import arrowLeft from './arrow-left.svg';
import arrowRight from './arrow-right.svg';
import arrowUp from './arrow-up.svg';
import atSvg from './at.svg';
import atom from './atom.svg';
import awardAlt from './award-alt.svg';
import backward from './backward.svg';
import balance from './balance.svg';
import basketball from './basketball.svg';
import bed from './bed.svg';
import bell from './bell.svg';
import bitcoin from './bitcoin.svg';
import bitkeep from './bitkeep.svg';
import bold from './bold.svg';
import bolt from './bolt.svg';
import book from './book.svg';
import books from './books.svg';
import branch from './branch.svg';
import brave from './brave.svg';
import bug from './bug.svg';
import building from './building.svg';
import bulletList from './bullet-list.svg';
import calculator from './calculator.svg';
import calendar from './calendar.svg';
import camera from './camera.svg';
import carriage from './carriage.svg';
import cart from './cart.svg';
import checkCircle from './check-circle.svg';
import check from './check.svg';
import checkboxEmpty from './checkbox-empty.svg';
import checkboxFilled from './checkbox-filled.svg';
import checkboxHalfFilled from './checkbox-half-filled.svg';
import chevronDown from './chevron-down.svg';
import chevronLeft from './chevron-left.svg';
import chevronRight from './chevron-right.svg';
import chevronUp from './chevron-up.svg';
import clearFormatting from './clear-formatting.svg';
import clipboard from './clipboard.svg';
import clock from './clock.svg';
import close from './close.svg';
import cloud from './cloud.svg';
import codeBlock from './code-block.svg';
import coffee from './coffee.svg';
import coinbase from './coinbase.svg';
import collapseH from './collapse-h.svg';
import collapseV from './collapse-v.svg';
import commentPlus from './comment-plus.svg';
import comment from './comment.svg';
import compass from './compass.svg';
import compose from './compose.svg';
import copy from './copy.svg';
import cornerDownLeft from './corner-down-left.svg';
import creditCard from './credit-card.svg';
import crosshairs from './crosshair.svg';
import curlyBrackets from './curly-brackets.svg';
import currency from './currency.svg';
import decreaseIndent from './decrease-indent.svg';
import desert from './desert.svg';
import desktop from './desktop.svg';
import dna from './dna.svg';
import dot from './dot-indicator.svg';
import doubleLeft from './double-left.svg';
import doubleRight from './double-right.svg';
import download from './download.svg';
import downward from './downward.svg';
import drag from './drag.svg';
import dumbbell from './dumbbell.svg';
import duplicate from './duplicate.svg';
import edit from './edit.svg';
import envelopeRead from './envelope-read.svg';
import envelopeSearch from './envelope-search.svg';
import envelopeUnread from './envelope-unread.svg';
import envelope from './envelope.svg';
import equation from './equation.svg';
import escape from './escape.svg';
import ethereum from './ethereum.svg';
import euro from './euro.svg';
import exit from './exit.svg';
import expandH from './expand-h.svg';
import expandV from './expand-v.svg';
import expand from './expand.svg';
import externalLink from './external-link.svg';
import eyeSlash from './eye-slash.svg';
import eye from './eye.svg';
import fileEmpty from './file-empty.svg';
import fileLock from './file-lock.svg';
import filePlus from './file-plus.svg';
import fileSlash from './file-slash.svg';
import fileSubpage from './file-subpage.svg';
import fileUpload from './file-upload.svg';
import fileX from './file-x.svg';
import file from './file.svg';
import film from './film.svg';
import filterPlus from './filter-plus.svg';
import filter from './filter.svg';
import fire from './fire.svg';
import flag from './flag.svg';
import flask from './flask.svg';
import flower from './flower.svg';
import folderArrow from './folder-arrow.svg';
import folderFilled from './folder-filled.svg';
import folderLock from './folder-lock.svg';
import folderPlus from './folder-plus.svg';
import folderSolid from './folder-solid.svg';
import folder from './folder.svg';
import football from './football.svg';
import forwardEmail from './forward-email.svg';
import forward from './forward.svg';
import fullView from './full-view.svg';
import gallery from './gallery.svg';
import gift from './gift.svg';
import globe from './globe.svg';
import gmail from './gmail.svg';
import googleCalendarSvg from './google-calendar.svg';
import googleDriveSvg from './googleDrive.svg';
import googleDriveColorSvg from './googleDriveColor.svg';
import graduation from './graduation.svg';
import grid from './grid.svg';
import h1 from './h1.svg';
import h2 from './h2.svg';
import h3 from './h3.svg';
import h4 from './h4.svg';
import h5 from './h5.svg';
import h6 from './h6.svg';
import heart from './heart.svg';
import highlight from './highlight.svg';
import history from './history.svg';
import home from './home.svg';
import horizontalRule from './horizontal-rule.svg';
import hourglass from './hourglass.svg';
import image from './image.svg';
import inbox from './inbox.svg';
import increaseIndent from './increase-indent.svg';
import info from './info.svg';
import ipfs from './ipfs.svg';
import italic from './italic.svg';
import key from './key.svg';
import lightbulb from './lightbulb.svg';
import lineChart from './line-chart.svg';
import link from './link.svg';
import lock from './lock.svg';
import mailbox from './mailbox.svg';
import mapMarker from './map-marker.svg';
import mapPin from './map-pin.svg';
import map from './map.svg';
import markdown from './markdown.svg';
import martini from './martini.svg';
import medkit from './medkit.svg';
import megaphone from './megaphone.svg';
import menu from './menu.svg';
import metamaskOutline from './metamask-outline.svg';
import metamask from './metamask.svg';
import meter from './meter.svg';
import minus from './minus.svg';
import mobile from './mobile.svg';
import moon from './moon.svg';
import moveMailbox from './move-mailbox.svg';
import musicNote from './music-note.svg';
import notificationBadge from './notification-badge.svg';
import numberList from './number-list.svg';
import number from './number.svg';
import numbers from './numbers.svg';
import orgStucture from './org-structure.svg';
import overflowH from './overflow-h.svg';
import overflowV from './overflow-v.svg';
import parcel from './package.svg';
import palette from './palette.svg';
import paperClip from './paperclip.svg';
import parent from './parent.svg';
import pdf from './pdf.svg';
import phantom from './phantom.svg';
import pieChart from './pie-chart.svg';
import plane from './plane.svg';
import plusCircle from './plus-circle.svg';
import plus from './plus.svg';
import podium from './podium.svg';
import pound from './pound.svg';
import prescriptionBottle from './prescription-bottle.svg';
import presentPlay from './present-play.svg';
import printerSvg from './printer.svg';
import processor from './processor.svg';
import python from './python.svg';
import qrcodeScan from './qrcode-scan.svg';
import questionCircle from './question-circle.svg';
import question from './question.svg';
import radioEmpty from './radio-empty.svg';
import radioFilled from './radio-filled.svg';
import redo from './redo.svg';
import reload from './reload.svg';
import remove from './remove.svg';
import replyAll from './reply-all.svg';
import reply from './reply.svg';
import restaurant from './restaurant.svg';
import robot from './robot.svg';
import rocket from './rocket.svg';
import save from './save.svg';
import screw from './screw.svg';
import search from './search.svg';
import send from './send.svg';
import server from './server.svg';
import settings from './settings.svg';
import shieldCheck from './shield-check.svg';
import shieldEncrypt from './shield-encrypt.svg';
import ship from './ship.svg';
import sign from './sign.svg';
import skiff from './skiff.svg';
import sliders from './sliders.svg';
import smilePlus from './smile-plus.svg';
import smile from './smile.svg';
import snowflake from './snowflake.svg';
import soccer from './soccer.svg';
import solana from './solana.svg';
import sortAscending from './sort-ascending.svg';
import sortDescending from './sort-descending.svg';
import sound from './sound.svg';
import spam from './spam.svg';
import spin from './spin.svg';
import splitView from './split-view.svg';
import star from './star.svg';
import stopwatch from './stopwatch.svg';
import strikethrough from './strikethrough.svg';
import sun from './sun.svg';
import syringe from './syringe.svg';
import tableTennis from './table-tennis.svg';
import table from './table.svg';
import tag from './tag.svg';
import telescope from './telescope.svg';
import temperature from './temperature.svg';
import tennisBall from './tennis-ball.svg';
import textField from './text-field.svg';
import textMono from './text-mono.svg';
import textSerif from './text-serif.svg';
import textSize from './text-size.svg';
import text from './text.svg';
import themes from './themes.svg';
import thumbsDown from './thumbs-down.svg';
import thumbsUp from './thumbs-up.svg';
import thunderstorm from './thunderstorm.svg';
import todo from './todo.svg';
import toggleHeader from './toggle-header.svg';
import toggleList from './toggle-list.svg';
import trafficBarrier from './traffic-barrier.svg';
import trafficCone from './traffic-cone.svg';
import trafficLight from './traffic-light.svg';
import train from './train.svg';
import trash from './trash.svg';
import trees from './trees.svg';
import trophy from './trophy.svg';
import truck from './truck.svg';
import tv from './tv.svg';
import umbrella from './umbrella.svg';
import underline from './underline.svg';
import undo from './undo.svg';
import university from './university.svg';
import unlink from './unlink.svg';
import unlock from './unlock.svg';
import unstoppableDark from './unstoppable-dark.svg';
import unstoppable from './unstoppable.svg';
import upload from './upload.svg';
import upward from './upward.svg';
import userCheck from './user-check.svg';
import userCircle from './user-circle.svg';
import userMinus from './user-minus.svg';
import userPlural from './user-plural.svg';
import userPlus from './user-plus.svg';
import userSquare from './user-square.svg';
import user from './user.svg';
import video from './video.svg';
import wallet from './wallet.svg';
import warning from './warning.svg';
import watermark from './watermark.svg';
import wifiSlash from './wifi-slash.svg';
import wifi from './wifi.svg';
import word from './word.svg';
import wrench from './wrench.svg';
import xCircle from './x-circle.svg';
import yen from './yen.svg';
import yinYang from './yin-yang.svg';
import zip from './zip.svg';
import zoomMinus from './zoom-minus.svg';
import zoomPlus from './zoom-plus.svg';

export const ARCHIVE_SVG = archive;
export const AT_SVG = atSvg;
export const ADDRESS_FIELD_SVG = addressField;
export const ALIGN_CENTER_SVG = alignCenter;
export const ALIGN_JUSTIFY_SVG = alignJustify;
export const ALIGN_LEFT_SVG = alignLeft;
export const ALIGN_RIGHT_SVG = alignRight;
export const ANCHOR_SVG = anchor;
export const AMBULANCE_SVG = ambulance;
export const ARROW_DOWN_SVG = arrowDown;
export const ARROW_LEFT_SVG = arrowLeft;
export const ARROW_RIGHT_SVG = arrowRight;
export const ARROW_UP_SVG = arrowUp;
export const ATOM_SVG = atom;
export const AWARD_ALT_SVG = awardAlt;
export const BACKWARD_SVG = backward;
export const BALANCE_SVG = balance;
export const BASKETBALL_SVG = basketball;
export const BED_SVG = bed;
export const BELL_SVG = bell;
export const BITCOIN_SVG = bitcoin;
export const BITKEEP_SVG = bitkeep;
export const BOLD_SVG = bold;
export const BOLT_SVG = bolt;
export const BOOK_SVG = book;
export const BOOKS_SVG = books;
export const BRANCH_SVG = branch;
export const BRAVE_SVG = brave;
export const BUG_SVG = bug;
export const BUILDING_SVG = building;
export const BULLET_LIST_SVG = bulletList;
export const CALCULATOR_SVG = calculator;
export const CALENDAR_SVG = calendar;
export const CAMERA_SVG = camera;
export const CARRIAGE_SVG = carriage;
export const CART_SVG = cart;
export const CHECK_CIRCLE_SVG = checkCircle;
export const CHECK_SVG = check;
export const CHECKBOX_HALF_FILLED_SVG = checkboxHalfFilled;
export const CHECKBOX_EMPTY_SVG = checkboxEmpty;
export const CHECKBOX_FILLED_SVG = checkboxFilled;
export const CHEVRON_UP_SVG = chevronUp;
export const CHEVRON_DOWN_SVG = chevronDown;
export const CHEVRON_LEFT_SVG = chevronLeft;
export const CHEVRON_RIGHT_SVG = chevronRight;
export const CLEAR_FORMATTING_SVG = clearFormatting;
export const CLIPBOARD_SVG = clipboard;
export const CLOCK_SVG = clock;
export const CLOSE_SVG = close;
export const CLOUD_SVG = cloud;
export const CODE_BLOCK_SVG = codeBlock;
export const COFFEE_SVG = coffee;
export const COINBASE_SVG = coinbase;
export const COLLAPSE_H_SVG = collapseH;
export const COLLAPSE_V_SVG = collapseV;
export const COMMENT_PLUS_SVG = commentPlus;
export const COMMENT_SVG = comment;
export const COMPASS_SVG = compass;
export const COMPOSE_SVG = compose;
export const COPY_SVG = copy;
export const CORNER_DOWN_LEFT_SVG = cornerDownLeft;
export const CREDIT_CARD_SVG = creditCard;
export const CROSSHAIRS_SVG = crosshairs;
export const CURLY_BRACKETS_SVG = curlyBrackets;
export const CURRENCY_SVG = currency;
export const DECREASE_INDENT_SVG = decreaseIndent;
export const DESERT_SVG = desert;
export const DESKTOP_SVG = desktop;
export const DNA_SVG = dna;
export const DOT_SVG = dot;
export const DOUBLE_LEFT_SVG = doubleLeft;
export const DOUBLE_RIGHT_SVG = doubleRight;
export const DOWNLOAD_SVG = download;
export const DOWNWARD_SVG = downward;
export const DRAG_SVG = drag;
export const DUMBBEL_SVG = dumbbell;
export const DUPLICATE_SVG = duplicate;
export const EDIT_SVG = edit;
export const ENVELOPE_SVG = envelope;
export const ENVELOPE_UNREAD_SVG = envelopeUnread;
export const ENVELOPE_READ_SVG = envelopeRead;
export const ENVELOPE_SEARCH_SVG = envelopeSearch;
export const EQUATION_SVG = equation;
export const EURO_SVG = euro;
export const ESCAPE_SVG = escape;
export const ETHEREUM_SVG = ethereum;
export const EXIT_SVG = exit;
export const EXPAND_SVG = expand;
export const EXPAND_H_SVG = expandH;
export const EXPAND_V_SVG = expandV;
export const EXTERNAL_LINK_SVG = externalLink;
export const EYE_SVG = eye;
export const EYE_SLASH_SVG = eyeSlash;
export const FILE_EMPTY_SVG = fileEmpty;
export const FILE_LOCK_SVG = fileLock;
export const FILE_PLUS_SVG = filePlus;
export const FILE_SLASH_SVG = fileSlash;
export const FILE_SUBPAGE_SVG = fileSubpage;
export const FILE_UPLOAD_SVG = fileUpload;
export const FILE_X_SVG = fileX;
export const FILE_SVG = file;
export const FILM_SVG = film;
export const FILTER_SVG = filter;
export const FILTER_PLUS_SVG = filterPlus;
export const FIRE_SVG = fire;
export const FLAG_SVG = flag;
export const FLASK_SVG = flask;
export const FLOWER_SVG = flower;
export const FOLDER_ARROW_SVG = folderArrow;
export const FOLDER_LOCK_SVG = folderLock;
export const FOLDER_PLUS_SVG = folderPlus;
export const FOLDER_SOLID_SVG = folderSolid;
export const FOLDER_SVG = folder;
export const FOLDER_FILLED_SVG = folderFilled;
export const FOOTBALL_SVG = football;
export const FORWARD_SVG = forward;
export const FORWARD_EMAIL_SVG = forwardEmail;
export const FULL_VIEW_SVG = fullView;
export const GALLERY_SVG = gallery;
export const GIFT_SVG = gift;
export const GLOBE_SVG = globe;
export const GMAIL_SVG = gmail;
export const GOOGLE_DRIVE_SVG = googleDriveSvg;
export const GOOGLE_DRIVE_COLOR_SVG = googleDriveColorSvg;
export const GOOGLE_CALENDAR_SVG = googleCalendarSvg;
export const GRADUATION_SVG = graduation;
export const GRID_SVG = grid;
export const H1_SVG = h1;
export const H2_SVG = h2;
export const H3_SVG = h3;
export const H4_SVG = h4;
export const H5_SVG = h5;
export const H6_SVG = h6;
export const HEART_SVG = heart;
export const HIGHLIGHT_SVG = highlight;
export const HISTORY_SVG = history;
export const HOME_SVG = home;
export const HORIZONTAL_RULE_SVG = horizontalRule;
export const HOURGLASS_SVG = hourglass;
export const IMAGE_SVG = image;
export const INBOX_SVG = inbox;
export const INCREASE_INDENT_SVG = increaseIndent;
export const INFO_SVG = info;
export const IPFS_SVG = ipfs;
export const ITALIC_SVG = italic;
export const KEY_SVG = key;
export const LIGHTBULB_SVG = lightbulb;
export const LINE_CHART_SVG = lineChart;
export const LINK_SVG = link;
export const LOCK_SVG = lock;
export const MAILBOX_SVG = mailbox;
export const MAP_MARKER_SVG = mapMarker;
export const MAP_PIN_SVG = mapPin;
export const MAP_SVG = map;
export const MARTINI_SVG = martini;
export const MEDKIT_SVG = medkit;
export const MEGAPHONE_SVG = megaphone;
export const MENU_SVG = menu;
export const METAMASK_SVG = metamask;
export const METAMASK_OUTLINE_SVG = metamaskOutline;
export const METER_SVG = meter;
export const MINUS_SVG = minus;
export const MOBILE_SVG = mobile;
export const MOON_SVG = moon;
export const MUSIC_NOTE_SVG = musicNote;
export const MOVE_MAILBOX_SVG = moveMailbox;
export const NOTIFICATION_BADGE_SVG = notificationBadge;
export const NUMBER_LIST_SVG = numberList;
export const NUMBER_SVG = number;
export const NUMBERS_SVG = numbers;
export const ORG_STRUCTURE_SVG = orgStucture;
export const OVERFLOW_H_SVG = overflowH;
export const OVERFLOW_V_SVG = overflowV;
export const PARCEL_SVG = parcel;
export const PALETTE_SVG = palette;
export const PAPER_CLIP_SVG = paperClip;
export const PARENT_SVG = parent;
export const PDF_SVG = pdf;
export const PHANTOM_SVG = phantom;
export const PIE_CHART_SVG = pieChart;
export const PLANE_SVG = plane;
export const PLUS_CIRCLE_SVG = plusCircle;
export const PLUS_SVG = plus;
export const PODIUM_SVG = podium;
export const POUND_SVG = pound;
export const PRESCRIPTION_BOTTLE_SVG = prescriptionBottle;
export const PRESENT_PLAY_SVG = presentPlay;
export const PRINTER_SVG = printerSvg;
export const PROCESSOR_SVG = processor;
export const QRCODE_SCAN_SVG = qrcodeScan;
export const QUESTION_CIRCLE_SVG = questionCircle;
export const QUESTION_SVG = question;
export const RADIO_EMPTY_SVG = radioEmpty;
export const RADIO_FILLED_SVG = radioFilled;
export const REDO_SVG = redo;
export const RELOAD_SVG = reload;
export const REMOVE_SVG = remove;
export const REPLY_SVG = reply;
export const REPLY_ALL_SVG = replyAll;
export const RESTAURANT_SVG = restaurant;
export const ROBOT_SVG = robot;
export const ROCKET_SVG = rocket;
export const SAVE_SVG = save;
export const SCREW_SVG = screw;
export const SEARCH_SVG = search;
export const SEND_SVG = send;
export const SERVER_SVG = server;
export const SETTINGS_SVG = settings;
export const SHIELD_CHECK_SVG = shieldCheck;
export const SHIELD_ENCRYPT_SVG = shieldEncrypt;
export const SHIP_SVG = ship;
export const SIGN_SVG = sign;
export const SLIDERS_SVG = sliders;
export const SMILE_SVG = smile;
export const SMILE_PLUS_SVG = smilePlus;
export const SNOWFLAKE_SVG = snowflake;
export const SOCCER_SVG = soccer;
export const SOLANA_SVG = solana;
export const SORT_ASCENDING_SVG = sortAscending;
export const SORT_DESCENDING_SVG = sortDescending;
export const SOUND_SVG = sound;
export const SPAM_SVG = spam;
export const SPIN_SVG = spin;
export const SPLIT_VIEW_SVG = splitView;
export const STAR_SVG = star;
export const STOPWATCH_SVG = stopwatch;
export const STRIKETHROUGH_SVG = strikethrough;
export const SUN_SVG = sun;
export const SYRINGE_SVG = syringe;
export const TABLE_SVG = table;
export const TABLE_TENNIS_SVG = tableTennis;
export const TAG_SVG = tag;
export const TELESCOPE_SVG = telescope;
export const TEMPERATURE_SVG = temperature;
export const TENNIS_BALL_SVG = tennisBall;
export const TEXT_SVG = text;
export const TEXT_FIELD_SVG = textField;
export const TEXT_MONO_SVG = textMono;
export const TEXT_SERIF_SVG = textSerif;
export const TEXT_SIZE_SVG = textSize;
export const THEMES_SVG = themes;
export const THUMBS_DOWN_SVG = thumbsDown;
export const THUMBS_UP_SVG = thumbsUp;
export const THUNDERSTORM_SVG = thunderstorm;
export const TODO_SVG = todo;
export const TOGGLE_HEADER_SVG = toggleHeader;
export const TOGGLE_LIST_SVG = toggleList;
export const TRAFFIC_BARRIER_SVG = trafficBarrier;
export const TRAFFIC_CONE_SVG = trafficCone;
export const TRAFFIC_LIGHT_SVG = trafficLight;
export const TRAIN_SVG = train;
export const TRASH_SVG = trash;
export const TREES_SVG = trees;
export const TROPHY_SVG = trophy;
export const TRUCK_SVG = truck;
export const TV_SVG = tv;
export const UMBRELLA_SVG = umbrella;
export const UNDERLINE_SVG = underline;
export const UNDO_SVG = undo;
export const UNIVERSITY_SVG = university;
export const UNLINK_SVG = unlink;
export const UNLOCK_SVG = unlock;
export const UNSTOPPABLE_SVG = unstoppable;
export const UNSTOPPABLE_DARK_SVG = unstoppableDark;
export const UPLOAD_SVG = upload;
export const UPWARD_SVG = upward;
export const USER_CHECK_SVG = userCheck;
export const USER_CIRCLE_SVG = userCircle;
export const USER_MINUS_SVG = userMinus;
export const USER_PLURAL_SVG = userPlural;
export const USER_PLUS_SVG = userPlus;
export const USER_SQUARE_SVG = userSquare;
export const USER_SVG = user;
export const WALLET_SVG = wallet;
export const WARNING_SVG = warning;
export const WATERMARK_SVG = watermark;
export const WIFI_SLASH_SVG = wifiSlash;
export const WIFI_SVG = wifi;
export const WRENCH_SVG = wrench;
export const X_CIRCLE_SVG = xCircle;
export const YEN_SVG = yen;
export const YIN_YANG_SVG = yinYang;
export const ZOOM_MINUS_SVG = zoomMinus;
export const ZOOM_PLUS_SVG = zoomPlus;
export const MARKDOWN_SVG = markdown;
export const SKIFF_SVG = skiff;
export const VIDEO_SVG = video;
export const WORD_SVG = word;
export const ZIP_SVG = zip;
export const PYTHON_SVG = python;
